import { render, staticRenderFns } from "./ProcurementSchedule.vue?vue&type=template&id=6ceff49d&scoped=true&"
import script from "./ProcurementSchedule.vue?vue&type=script&lang=js&"
export * from "./ProcurementSchedule.vue?vue&type=script&lang=js&"
import style0 from "./ProcurementSchedule.vue?vue&type=style&index=0&id=6ceff49d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ceff49d",
  null
  
)

export default component.exports